import Enumerator from '../global/Enumerator';

export const objectivePreferredDurationOptions = [
  'none',
  'six_months',
  'twelve_months',
  'up_to_one_year',
  'eighteen_months',
  'one_to_three_years',
  'two_years',
  'three_to_five_years',
  'two_years_plus',
  'five_years_plus'
];

export class ObjectivePreferredDurationOption extends Enumerator {
  static default() {
    return this.of('none');
  }

  static of(option?: string) {
    let correctOption = option;
    switch (option) {
      case '1':
        correctOption = 'six_months';
        break;
      case '2':
        correctOption = 'twelve_months';
        break;
      case 'i1':
        correctOption = 'up_to_one_year';
        break;
      case '3':
        correctOption = 'eighteen_months';
        break;
      case 'i2':
        correctOption = 'one_to_three_years';
        break;
      case '4':
        correctOption = 'two_years';
        break;
      case 'i3':
        correctOption = 'three_to_five_years';
        break;
      case '5':
        correctOption = 'two_years_plus';
        break;
      case 'i4':
        correctOption = 'five_years_plus';
        break;
      default:
        break;
    }
    return this.enumValueOf(correctOption) || this.default();
  }
}

ObjectivePreferredDurationOption.initEnum({
  none: {
    get title() {
      return 'None';
    }
  },
  six_months: {
    get title() {
      return '6 months';
    }
  },
  twelve_months: {
    get title() {
      return '12 months';
    }
  },
  up_to_one_year: {
    get title() {
      return 'Up to 1 year';
    }
  },
  eighteen_months: {
    get title() {
      return '18 months';
    }
  },
  one_to_three_years: {
    get title() {
      return '1 to 3 years';
    }
  },
  two_years: {
    get title() {
      return '2 years';
    }
  },
  three_to_five_years: {
    get title() {
      return '3 to 5 years';
    }
  },
  two_years_plus: {
    get title() {
      return '2 years plus';
    }
  },
  five_years_plus: {
    get title() {
      return '5 years plus';
    }
  }
});

export default {
  objectivePreferredDurationOptions,
  ObjectivePreferredDurationOption
};
